<h4 class="font-weight-bold py-3 mb-4">Professionals</h4>
<div class="card mb-4">
  <h6 class="card-header">
    Request Access to Profile
  </h6>
  <div class="row no-gutters row-bordered">
    <div class="col-sm-12 p-4">
      <form>
        <div class="form-row">
          <div class="form-group col-md-4">
            <label class="form-label">Access Code</label>
            <div class="input-group">
              <input name="identifier" type="text" class="form-control" placeholder="xxx-xxxx-xxx" [(ngModel)]="accessCode">
            </div>
          </div>
        </div>
        <button type="submit" class="btn btn-primary" (click)="searchByAccessCode()">Search Access Code</button>
        <p></p>
        <div class="form-row" *ngIf="accessUser">
          <div class="form-group col-md-4">
            <label class="form-label">Professional Found</label>
            <div class="input-group">
              {{accessUser.fullname}}&nbsp;
              <button class="btn btn-xs btn-primary" *ngIf="!accessRequested(accessUser) && !accessGranted(accessUser)" (click)="requestAccess(accessUser)">Request Access</button>
              <span *ngIf="accessRequested(accessUser)"> (Access Requested)</span>
              <span *ngIf="accessGranted(accessUser)"> (Access Already Granted)</span>
            </div>
          </div>
        </div>
        <div class="form-row" *ngIf="searched && !accessUser">
          <div class="form-group col-md-4">
            <label class="form-label" style="color: darkred">No professional found for this code.</label>
          </div>
        </div>
      </form>
    </div>
  </div>

</div>


<div class="card mb-4">
  <h6 class="card-header">
    Access Overview
  </h6>
  <div class="row no-gutters row-bordered">
    <div class="col-sm-12 p-4">
      <table class="table table-striped">
        <thead>
        <tr>
          <th>Name</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let user of getProfessionals() | filter:canView()" class="certificate-add">
          <td>{{user.fullname}}</td>
          <td>
            <span *ngIf="accessRequested(user)">Access Requested</span>
            <span *ngIf="accessGranted(user)">Access Granted</span>
          </td>
          <td>
            <button class="btn btn-sm btn-primary" *ngIf="accessGranted(user)" (click)="gotoProfessional(user.id)">Go to certificates</button>
          </td>
        </tr>
        <tr *ngIf="(getProfessionals() | filter:canView()).length === 0">
          <td colspan="3" style="text-align: center">
            There are currently no professionals whose profile you can access
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
